import { MODAL_Z_INDEX } from '../../components/modal/modal.style';
import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-LongRunningTaskManager',
	popover: 'c-LongRunningTaskManager__popover',
	popoverOpening: 'c-LongRunningTaskManager__popover--opening',
	popoverClosing: 'c-LongRunningTaskManager__popover--closing',
	header: 'c-LongRunningTaskManager__header',
	title: 'c-LongRunningTaskManager__title',
	table: 'c-LongRunningTaskManager__table',
	row: 'c-LongRunningTaskManager__row',
	rowClickable: 'c-LongRunningTaskManager__row--clickable',
	cellType: 'c-LongRunningTaskManager__cell--type',
	cellJob: 'c-LongRunningTaskManager__cell--job',
	cellStatus: 'c-LongRunningTaskManager__cell--status',
	cellAction: 'c-LongRunningTaskManager__cell--action',
	cellIndicator: 'c-LongRunningTaskManager__cell--indicator',
	unseenDot: 'c-LongRunningTaskManager__unseen-dot',
	unseenDotComplete: 'c-LongRunningTaskManager__unseen-dot--complete',
	unseenDotWarning: 'c-LongRunningTaskManager__unseen-dot--warning',
	unseenDotError: 'c-LongRunningTaskManager__unseen-dot--error',
	statusProcessing: 'c-LongRunningTaskManager__status--processing',
	statusComplete: 'c-LongRunningTaskManager__status--complete',
	statusDownloaded: 'c-LongRunningTaskManager__status--downloaded',
	statusWarning: 'c-LongRunningTaskManager__status--warning',
	statusError: 'c-LongRunningTaskManager__status--error',
	actionIcon: 'c-LongRunningTaskManager__action-icon',
	actionWarning: 'c-LongRunningTaskManager__action-icon--warning',
	actionError: 'c-LongRunningTaskManager__action-icon--error',
	badge: 'c-LongRunningTaskManager__badge',
	clearButton: 'c-LongRunningTaskManager__clear-button',
	empty: 'c-LongRunningTaskManager__empty',
	pulse: 'c-LongRunningTaskManager--pulse',
};

export const Style = {
	[CSS.container]: {
		position: 'relative',
		display: 'inline-block',
	},
	[CSS.popover]: {
		position: 'absolute',
		top: DefaultTheme.space(9),
		right: DefaultTheme.space(1),
		'min-width': '480px',
		padding: `${DefaultTheme.space(1)} 0`,
		'z-index': MODAL_Z_INDEX - 1,
		color: DefaultTheme.font.color.supporting,
		'background-color': DefaultTheme.background.offWhite,
		display: 'flex',
		'flex-direction': 'column',
		'border-radius': '8px',
		overflow: 'hidden',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		opacity: 1,
		transform: 'translateY(0)',
		'transform-origin': 'top right',
		transition: 'opacity .15s ease-in-out, transform .15s ease-in-out',
	},
	[CSS.popoverOpening]: {
		opacity: 0,
		transform: 'translateY(-4px) scale(0.98)',
	},
	[CSS.popoverClosing]: {
		opacity: 0,
		transform: 'translateY(-4px) scale(0.98)',
		'pointer-events': 'none',
	},
	[CSS.header]: {
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
	},
	[CSS.title]: {
		'font-weight': DefaultTheme.font.weight.bold,
		color: DefaultTheme.font.color.primary,
	},
	[CSS.table]: {
		display: 'flex',
		'flex-direction': 'column',
		'max-height': '320px',
		'overflow-y': 'auto',
	},
	[CSS.row]: {
		color: DefaultTheme.font.color.supporting,
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		'line-height': DefaultTheme.space(8),
		display: 'flex',
		'align-items': 'center',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		transition: 'background-color .12s ease',
		'&:hover': {
			'background-color': DefaultTheme.background.lightGrey,
		},
	},
	[CSS.rowClickable]: {
		cursor: 'pointer',
	},
	[CSS.cellIndicator]: {
		width: '20px',
		'flex-shrink': 0,
		display: 'flex',
		'align-items': 'center',
	},
	[CSS.cellType]: {
		width: '80px',
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
		'white-space': 'nowrap',
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'padding-right': DefaultTheme.space(2),
	},
	[CSS.cellJob]: {
		flex: 1,
		color: DefaultTheme.font.color.primary,
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
		'padding-right': DefaultTheme.space(2),
	},
	[CSS.cellStatus]: {
		width: '80px',
		'flex-shrink': 0,
		'text-align': 'right',
		'font-size': '12px',
		'padding-right': DefaultTheme.space(1),
	},
	[CSS.cellAction]: {
		width: '36px',
		'flex-shrink': 0,
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
	},
	[CSS.unseenDot]: {
		width: '8px',
		height: '8px',
		'border-radius': '50%',
	},
	[CSS.unseenDotComplete]: {
		background: ColorPalette2022Branding.darkGreen,
	},
	[CSS.unseenDotWarning]: {
		background: ColorPalette2022Branding.ikeOrange,
	},
	[CSS.unseenDotError]: {
		background: ColorPalette2022Branding.lightRed,
	},
	[CSS.statusProcessing]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.statusComplete]: {
		color: ColorPalette2022Branding.darkGreen,
	},
	[CSS.statusDownloaded]: {
		color: ColorPalette2022Branding.darkGreen,
		opacity: 0.6,
	},
	[CSS.statusWarning]: {
		color: ColorPalette2022Branding.ikeOrange,
	},
	[CSS.statusError]: {
		color: ColorPalette2022Branding.lightRed,
	},
	[CSS.actionIcon]: {
		color: 'rgba(0,0,0,0.54)',
		'font-size': '20px',
	},
	[CSS.actionWarning]: {
		color: ColorPalette2022Branding.ikeOrange,
	},
	[CSS.actionError]: {
		color: ColorPalette2022Branding.lightRed,
	},
	[CSS.badge]: {
		position: 'absolute',
		top: '2px',
		right: '2px',
		background: ColorPalette2022Branding.lightRed,
		color: 'white',
		'border-radius': '50%',
		width: '16px',
		height: '16px',
		'font-size': '10px',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'pointer-events': 'none',
	},
	[CSS.clearButton]: {
		background: 'none',
		border: 'none',
		color: DefaultTheme.font.color.supporting,
		cursor: 'pointer',
		'font-size': DefaultTheme.font.size,
		'font-family': DefaultTheme.font.family,
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		'border-radius': '4px',
		transition: 'background-color .12s ease, color .12s ease',
		'&:hover:not(:disabled)': {
			'background-color': DefaultTheme.background.lightGrey,
			color: DefaultTheme.font.color.primary,
		},
		'&:disabled': {
			opacity: 0.4,
			cursor: 'default',
		},
	},
	[CSS.empty]: {
		padding: `${DefaultTheme.space(4)} ${DefaultTheme.space(3)}`,
		color: DefaultTheme.font.color.disabled,
		'text-align': 'center',
	},
	'@keyframes dm-pulse': {
		'0%': { 'box-shadow': '0 0 0 0 rgba(255, 146, 57, 0.8)', transform: 'scale(1)' },
		'50%': { 'box-shadow': '0 0 12px 8px rgba(255, 146, 57, 0.6)', transform: 'scale(1.1)' },
		'100%': { 'box-shadow': '0 0 0 0 rgba(255, 146, 57, 0)', transform: 'scale(1)' },
	},
	[CSS.pulse]: {
		animation: 'dm-pulse 1.5s ease-in-out infinite',
		'border-radius': '50%',
	},
};
